import type { ReactElement } from 'react'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { useExperienceLuxPlusCarouselProps } from 'hooks/Experiences/useExperienceLuxPlusCarouselProps'

interface Props {
  place?: App.Place
  title?: string | ReactElement
  subtitle?: string
  minimumOffersCount?: number
}

function ExperienceLuxPlusCarousel(props: Props) {
  const { place, title, subtitle, minimumOffersCount } = props

  const luxPlusCarouselProps = useExperienceLuxPlusCarouselProps({
    place,
    title,
    subtitle,
  })

  if (!luxPlusCarouselProps) return null

  return (
    <OfferCardCarouselSection {...luxPlusCarouselProps} minimumOffersCount={minimumOffersCount} data-testid="luxplus-experiences-carousel" />
  )
}

export default ExperienceLuxPlusCarousel
